var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 10.3737C8.15903 10.3737 8.31164 10.4369 8.42417 10.5495C8.53669 10.662 8.5999 10.8146 8.5999 10.9737C8.5999 11.1329 8.53669 11.2855 8.42417 11.398C8.31164 11.5105 8.15903 11.5737 7.9999 11.5737C7.84077 11.5737 7.68816 11.5105 7.57564 11.398C7.46312 11.2855 7.3999 11.1329 7.3999 10.9737C7.3999 10.8146 7.46312 10.662 7.57564 10.5495C7.68816 10.4369 7.84077 10.3737 7.9999 10.3737Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5Z",
    stroke: "#EF4444",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.28528V8.88513",
    stroke: "#EF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleRed);
export default __webpack_public_path__ + "static/media/alert_circle_red.bf2e7d8844ad46eebf405f2ab1190b36.svg";
export { ForwardRef as ReactComponent };